export const diagnosticTestIds: Record<string, string> = {
  careerLiteracyScreeningTestId: '13a8be7a-87fe-4528-b960-a44f2025e7d9',
  careerLiteracyScreeningTestId2: '465f6729-3ad9-4047-854c-b17a4634e658',
  diagnosticByCareerTypeTestId: 'e2793f84-b89d-4a82-8277-8797630acbd9',
  outputDiagnosticMurmansk: '2fb8e5f4-e60e-48cb-9df5-90afa495b44b',
  outputDiagnosticBashkortostan: '70992878-4a46-45ed-a4b3-505d4f84ce01',
  outputDiagnosticYanao6_7: '4c13ab3c-2326-4083-ae33-1fa268ba210d',
  outputDiagnosticYanao8_11: 'ebfec351-a114-462d-8da5-3d9f98ec7c3b',
};
